import React, {Component} from "react";

import './checkbox.css'

import {ReactComponent as CheckboxActiveIcon} from "../../../images/icons/ui/checkbox/active.svg"
import {ReactComponent as CheckboxEmptyIcon} from "../../../images/icons/ui/checkbox/empty.svg";

class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked || false,
        };
    }

    handleChange = () => {
        this.setState((prevState) => ({checked: !prevState.checked}));
        if (this.props.onChange) {
            this.props.onChange(!this.state.checked);
        }
    };

    render() {
        const activeIcon = this.props.activeIcon ? this.props.activeIcon : <CheckboxActiveIcon/>
        const emptyIcon = this.props.emptyIcon ? this.props.emptyIcon : <CheckboxEmptyIcon/>

        return (
            <div className='checkbox' onClick={this.handleChange}>
                {this.props.checked || false ? activeIcon : emptyIcon}
            </div>
        );
    }
}

export default Checkbox;